module.exports = __webpack_public_path__ + "img/IMG_1867_L_Wood_MockedUp.514abc47.jpg";